module.exports = ->
  (record) ->
    if record.statement_recordable_type
      "#{record.statement_recordable_type}: #{record.statement_recordable_id}"
    else
      "Adjustment: #{record.id}"
